import { agentConstants } from '../_constants/agent.constant';
import { getAllData } from '../services/ApiCallingUserServices';

export const agentActions = {
    getAgentOptions
};

function getAgentOptions() {
    return async (dispatch: any, getState: any) => {
        const { agentOptions } = getState();
        
        // If data already exists, don't fetch again
        if (agentOptions?.data) {
            return;
        }

        dispatch({ type: agentConstants.GET_AGENT_OPTIONS_REQUEST });

        try {
            const res = await getAllData('/midoffice/v1/getagentoption');
            if (res?.status && res?.data) {
                dispatch({ 
                    type: agentConstants.GET_AGENT_OPTIONS_SUCCESS, 
                    data: res.data 
                });
            } else {
                dispatch({ 
                    type: agentConstants.GET_AGENT_OPTIONS_FAILURE, 
                    error: res?.message || 'Failed to fetch options' 
                });
            }
        } catch (error: any) {
            dispatch({ 
                type: agentConstants.GET_AGENT_OPTIONS_FAILURE, 
                error: error.toString() 
            });
        }
    };
}
